import React from 'react';
import { Form, ListGroup, Badge, InputGroup, Button } from 'react-bootstrap';
import { useMessaging } from '../../../features/messaging/MessagingContext';
import InfiniteScroll from 'react-infinite-scroll-component';

const Sidebar = () => {
    const { state, dispatch } = useMessaging();
    const {
        contacts, searchQuery, filter,
        selectedTags, selectedBranches,
        selectedAdmissionStatuses
    } = state;

    // Filter Logic
    const filteredContacts = contacts.filter(contact => {
        const matchesSearch = contact.name.toLowerCase().includes(searchQuery.toLowerCase());
        const matchesMainFilter = filter === 'all' || (filter === 'unread' && contact.unreadCount > 0);

        // Advanced Filters
        const matchesBranches = selectedBranches.length === 0 || selectedBranches.some(b => b.value === contact.branchId);
        const matchesTags = selectedTags.length === 0 || selectedTags.some(t => contact.tags?.includes(t.value));
        const matchesStatus = selectedAdmissionStatuses.length === 0 || selectedAdmissionStatuses.some(s => s.value === contact.status);

        return matchesSearch && matchesMainFilter && matchesBranches && matchesTags && matchesStatus;
    });

    return (
        <div className="d-flex flex-column h-100 bg-white">
            <div className="sidebar-header p-3 border-bottom shadow-sm">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0 font-weight-bold text-navy-blue">Conversations</h5>
                    <div className="small text-muted font-weight-500">
                        {filteredContacts.length} Total
                    </div>
                </div>

                <InputGroup className="message-search-input rounded-pill shadow-inner overflow-hidden mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text className="bg-transparent border-0 pl-3">
                            <i className="fas fa-search text-muted opacity-50" />
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                        placeholder="Search chats..."
                        className="border-0 bg-transparent shadow-none small"
                        value={searchQuery}
                        onChange={(e) => dispatch({ type: 'SET_SEARCH', payload: e.target.value })}
                    />
                </InputGroup>

                <div className="d-flex align-items-center">
                    <Button
                        variant={filter === 'all' ? 'primary' : 'outline-light'}
                        size="sm"
                        className={`rounded-pill mr-2 font-weight-bold border-0 shadow-none px-3 ${filter === 'all' ? 'btn-navy-blue' : 'text-muted'}`}
                        onClick={() => dispatch({ type: 'SET_FILTER', payload: 'all' })}
                    >
                        All
                    </Button>
                    <Button
                        variant={filter === 'unread' ? 'primary' : 'outline-light'}
                        size="sm"
                        className={`rounded-pill font-weight-bold border-0 shadow-none px-3 ${filter === 'unread' ? 'btn-navy-blue' : 'text-muted'}`}
                        onClick={() => dispatch({ type: 'SET_FILTER', payload: 'unread' })}
                    >
                        Unread
                    </Button>
                </div>
            </div>

            <div id="contact-list" className="flex-grow-1 overflow-auto bg-slate-50 pt-2">
                <InfiniteScroll
                    dataLength={filteredContacts.length}
                    next={() => { }}
                    hasMore={false}
                    loader={null}
                    scrollableTarget="contact-list"
                >
                    <ListGroup variant="flush">
                        {filteredContacts.length === 0 ? (
                            <div className="text-center py-5">
                                <i className="fas fa-comments text-muted opacity-20 fa-3x mb-3" />
                                <p className="text-muted small px-4">No results found for your search.</p>
                            </div>
                        ) : (
                            filteredContacts.map(contact => (
                                <ListGroup.Item
                                    key={contact.id}
                                    action
                                    onClick={() => dispatch({ type: 'SELECT_CONTACT', payload: contact })}
                                    className={`p-3 d-flex align-items-start border-0 mx-2 mb-1 rounded-lg transition-all contact-item-pro ${state.selectedContact?.id === contact.id ? 'active-pro' : ''}`}
                                >
                                    <div className="contact-avatar mr-3">
                                        <div className={`avatar-pill rounded-circle text-white d-flex align-items-center justify-content-center shadow-sm`}>
                                            {contact.name.charAt(0)}
                                        </div>
                                    </div>
                                    <div className="flex-grow-1 min-width-0">
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <h6 className={`mb-0 font-weight-bold text-truncate ${state.selectedContact?.id === contact.id ? 'text-white' : 'text-dark'}`}>{contact.name}</h6>
                                            <small className={`${state.selectedContact?.id === contact.id ? 'text-white-50' : 'text-muted'}`}>{contact.time}</small>
                                        </div>
                                        <p className={`small mb-0 text-truncate ${state.selectedContact?.id === contact.id ? 'text-white-50' : 'text-muted'}`}>
                                            {contact.lastMessage}
                                        </p>
                                    </div>
                                    {contact.unreadCount > 0 && state.selectedContact?.id !== contact.id && (
                                        <Badge variant="primary" pill className="ml-2 mt-1 px-2 py-1 bg-royal-blue shadow-sm">
                                            {contact.unreadCount}
                                        </Badge>
                                    )}
                                </ListGroup.Item>
                            ))
                        )}
                    </ListGroup>
                </InfiniteScroll>
            </div>
        </div>
    );
};

export default Sidebar;
